/**
 * snackbar
 */

const systemMessageDialog = {
  namespaced: true,
  state: {
    show: false,
    title: null,
    message: null,
    title_color: 'info'
  },
  getters: {},
  actions: {
    // enableErrorDialog ({ commit }, { message }) {
    //   commit('showInfo', { message: message })
    // },
    hide ({ commit }) {
      commit('hide')
    },
  },
  mutations: {
    showInfo (state, { message }) {
      state.show = true
      state.message = message
      state.title_color = 'info'
    },
    showError (state, { title, message }) {
      state.show = true
      state.title = title
      state.message = message
      state.title_color = 'error'
    },
    hide (state) {
      state.show = false
      state.message = null
      state.title_color = 'info'
    }
  },
}

export default systemMessageDialog
